/**
 * Estabelecimento View Dialog Component
 */

import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Badge } from "@/components/ui/badge";
import { Estabelecimento } from "@/types/estabelecimento";
import { format } from "date-fns";

interface EstabelecimentoViewDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  estabelecimento: Estabelecimento | null;
}

export function EstabelecimentoViewDialog({
  open,
  onOpenChange,
  estabelecimento,
}: EstabelecimentoViewDialogProps) {
  if (!estabelecimento) return null;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl">
        <DialogHeader>
          <DialogTitle>Detalhes do Estabelecimento</DialogTitle>
        </DialogHeader>

        <div className="space-y-4">
          <div>
            <h3 className="font-semibold text-lg">{estabelecimento.nome}</h3>
          </div>

          <div className="grid grid-cols-2 gap-4">
            {estabelecimento.cnpj && (
              <div>
                <p className="text-sm text-muted-foreground">CNPJ</p>
                <p className="font-medium">{estabelecimento.cnpj}</p>
              </div>
            )}

            {estabelecimento.responsavel && (
              <div>
                <p className="text-sm text-muted-foreground">Responsável</p>
                <p className="font-medium">{estabelecimento.responsavel}</p>
              </div>
            )}

            {estabelecimento.telefone && (
              <div>
                <p className="text-sm text-muted-foreground">Telefone</p>
                <p className="font-medium">{estabelecimento.telefone}</p>
              </div>
            )}

            {estabelecimento.email && (
              <div>
                <p className="text-sm text-muted-foreground">Email</p>
                <p className="font-medium">{estabelecimento.email}</p>
              </div>
            )}

            {estabelecimento.endereco && (
              <div className="col-span-2">
                <p className="text-sm text-muted-foreground">Endereço</p>
                <p className="font-medium">{estabelecimento.endereco}</p>
              </div>
            )}

            {estabelecimento.observacoes && (
              <div className="col-span-2">
                <p className="text-sm text-muted-foreground">Observações</p>
                <p className="font-medium">{estabelecimento.observacoes}</p>
              </div>
            )}

            <div>
              <p className="text-sm text-muted-foreground">Data de Criação</p>
              <p className="font-medium">
                {format(new Date(estabelecimento.created_at), "dd/MM/yyyy HH:mm")}
              </p>
            </div>

            <div>
              <p className="text-sm text-muted-foreground">Última Atualização</p>
              <p className="font-medium">
                {format(new Date(estabelecimento.updated_at), "dd/MM/yyyy HH:mm")}
              </p>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
}
